/** A practice's public link-in-bio page. */
export const LINK_IN_BIO_PATH = "/links";
